export const episodes = [
  {
    id: 1,
    number: 1,
    title: "意外的礼物",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20chinese%20woman%20sitting%20by%20a%20sunlit%20window%20holding%20a%20tiny%20baby%20blanket%2C%20soft%20golden%20afternoon%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20quiet%20emotional%20mood%2C%20hygge%20interior&width=640&height=360&seq=young-mother-ep01&orientation=landscape",
    airDate: "2025-03-01",
    duration: "45:12",
    director: "陈望舒",
    cast: "林书言、周慕、陈望舒",
    summary:
      "二十四岁的林晚在一场意外的雨夜里迎来了人生的转折，一件来不及准备的礼物悄然降临，她必须在惶恐与勇气之间做出第一个选择。",
    tags: ["开篇", "转折", "家庭"],
    views: "286.4万",
  },
  {
    id: 2,
    number: 2,
    title: "第一次心跳",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20lying%20in%20a%20cozy%20bedroom%20at%20dawn%20looking%20thoughtful%2C%20soft%20pink%20morning%20light%20through%20sheer%20curtains%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20intimate%20quiet%20emotion&width=640&height=360&seq=young-mother-ep02&orientation=landscape",
    airDate: "2025-03-02",
    duration: "44:38",
    director: "陈望舒",
    cast: "林书言、周慕、赵一宁",
    summary:
      "第一次产检的心跳声让林晚忽然意识到，她的世界里多了一个无法后退的理由。家人的态度却让这份喜悦蒙上阴影。",
    tags: ["抉择", "亲情"],
    views: "251.9万",
  },
  {
    id: 3,
    number: 3,
    title: "沉默的产检单",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20holding%20a%20medical%20report%20in%20a%20hospital%20corridor%2C%20soft%20diffused%20daylight%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20tense%20yet%20tender%20mood&width=640&height=360&seq=young-mother-ep03&orientation=landscape",
    airDate: "2025-03-08",
    duration: "45:05",
    director: "陈望舒",
    cast: "林书言、周慕、苏敏",
    summary:
      "一纸产检单被反复折叠又展开。林晚在沉默中读懂了母亲眼里的担忧，也读到了自己从未说出口的倔强。",
    tags: ["医院", "母女"],
    views: "233.7万",
  },
  {
    id: 4,
    number: 4,
    title: "母亲的手",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20an%20elderly%20mother%20holding%20her%20daughter%20hand%20across%20a%20wooden%20kitchen%20table%2C%20warm%20amber%20evening%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20tender%20family%20emotion&width=640&height=360&seq=young-mother-ep04&orientation=landscape",
    airDate: "2025-03-09",
    duration: "45:20",
    director: "陈望舒",
    cast: "林书言、苏敏、周慕",
    summary:
      "母亲粗糙的手掌抚过林晚的发梢，两代女人在厨房的氤氲热气里，完成了多年未曾有过的和解与托付。",
    tags: ["母女", "和解"],
    views: "244.2万",
  },
  {
    id: 5,
    number: 5,
    title: "深夜的抉择",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20standing%20alone%20on%20a%20balcony%20at%20night%20over%20city%20lights%2C%20soft%20bokeh%20lamps%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20reflective%20lonely%20mood&width=640&height=360&seq=young-mother-ep05&orientation=landscape",
    airDate: "2025-03-15",
    duration: "44:52",
    director: "陈望舒",
    cast: "林书言、周慕、赵一宁",
    summary:
      "城市的灯火在脚下铺开，林晚必须决定是否留下这个孩子，以及是否留下那个始终犹豫的男人。",
    tags: ["抉择", "都市"],
    views: "268.9万",
  },
  {
    id: 6,
    number: 6,
    title: "陌生的城市",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20with%20a%20suitcase%20arriving%20in%20an%20unfamiliar%20city%20street%20at%20dusk%2C%20warm%20street%20lamps%20glowing%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20hopeful%20uncertain%20mood&width=640&height=360&seq=young-mother-ep06&orientation=landscape",
    airDate: "2025-03-16",
    duration: "45:00",
    director: "陈望舒",
    cast: "林书言、沈知远、周慕",
    summary:
      "离开熟悉的地方，林晚拖着行李走进一座陌生城市。她不知道，新的开始往往藏在最陌生的街角。",
    tags: ["新生活", "都市"],
    views: "215.6万",
  },
  {
    id: 7,
    number: 7,
    title: "新的开始",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20unpacking%20boxes%20in%20a%20small%20bright%20rented%20apartment%2C%20sunny%20afternoon%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20fresh%20hopeful%20mood&width=640&height=360&seq=young-mother-ep07&orientation=landscape",
    airDate: "2025-03-22",
    duration: "44:47",
    director: "陈望舒",
    cast: "林书言、沈知远、苏敏",
    summary:
      "小小的出租屋被一盏暖灯点亮，林晚第一次认真规划起自己和孩子的未来，也遇见了愿意搭把手的邻居。",
    tags: ["新生活", "温暖"],
    views: "208.1万",
  },
  {
    id: 8,
    number: 8,
    title: "一份工作",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20filling%20out%20job%20applications%20at%20a%20small%20desk%20with%20paperwork%2C%20soft%20morning%20window%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20determined%20quiet%20mood&width=640&height=360&seq=young-mother-ep08&orientation=landscape",
    airDate: "2025-03-23",
    duration: "45:11",
    director: "陈望舒",
    cast: "林书言、沈知远、赵一宁",
    summary:
      "为了养活孩子，林晚第一次直面社会的冷眼。一份看似微不足道的工作，却成了她重新站起来的支点。",
    tags: ["职场", "成长"],
    views: "199.4万",
  },
  {
    id: 9,
    number: 9,
    title: "她叫什么名字",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20mother%20gently%20holding%20her%20newborn%20daughter%20in%20soft%20blanket%2C%20warm%20golden%20nursery%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20loving%20tender%20mood&width=640&height=360&seq=young-mother-ep09&orientation=landscape",
    airDate: "2025-03-29",
    duration: "45:03",
    director: "陈望舒",
    cast: "林书言、沈知远、苏敏",
    summary:
      "为女儿取名的那一夜，林晚翻遍了旧相册。名字里藏着两代人的期盼，也藏着一段她不愿再提起的往事。",
    tags: ["亲情", "回忆"],
    views: "221.3万",
  },
  {
    id: 10,
    number: 10,
    title: "雨夜的争执",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20two%20people%20arguing%20under%20a%20streetlight%20in%20gentle%20rain%20at%20night%2C%20wet%20pavement%20reflections%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20tense%20emotional%20mood&width=640&height=360&seq=young-mother-ep10&orientation=landscape",
    airDate: "2025-03-30",
    duration: "44:59",
    director: "陈望舒",
    cast: "林书言、周慕、沈知远",
    summary:
      "积压已久的情绪在雨夜爆发。周慕的犹豫与林晚的坚持针锋相对，一句气话让两人之间裂开一道难以愈合的缝。",
    tags: ["冲突", "情感"],
    views: "246.8万",
  },
  {
    id: 11,
    number: 11,
    title: "旧照片",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20woman%20looking%20through%20old%20family%20photographs%20in%20a%20drawer%20by%20lamp%20light%2C%20warm%20amber%20interior%20glow%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20nostalgic%20mood&width=640&height=360&seq=young-mother-ep11&orientation=landscape",
    airDate: "2025-04-05",
    duration: "45:16",
    director: "陈望舒",
    cast: "林书言、苏敏、沈知远",
    summary:
      "一张泛黄的旧照片揭开了母亲年轻时的秘密，林晚第一次以女人的身份理解了母亲当年的沉默与坚持。",
    tags: ["回忆", "母女"],
    views: "212.5万",
  },
  {
    id: 12,
    number: 12,
    title: "病房外的长椅",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20sitting%20alone%20on%20a%20bench%20outside%20a%20hospital%20ward%20at%20night%2C%20soft%20fluorescent%20glow%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20anxious%20weary%20mood&width=640&height=360&seq=young-mother-ep12&orientation=landscape",
    airDate: "2025-04-06",
    duration: "45:08",
    director: "陈望舒",
    cast: "林书言、苏敏、周慕",
    summary:
      "母亲突然病倒，林晚守着病房外的长椅彻夜未眠。在恐惧与责任之间，她被迫长大了最后一步。",
    tags: ["亲情", "考验"],
    views: "238.0万",
  },
  {
    id: 13,
    number: 13,
    title: "第一个微笑",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20baby%20smiling%20in%20a%20young%20mother%20arms%20in%20a%20sunny%20living%20room%2C%20soft%20golden%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20joyful%20tender%20mood&width=640&height=360&seq=young-mother-ep13&orientation=landscape",
    airDate: "2025-04-12",
    duration: "44:44",
    director: "陈望舒",
    cast: "林书言、沈知远、赵一宁",
    summary:
      "女儿第一次对林晚露出笑容，所有疲惫在那一刻烟消云散。她终于明白，选择留下是此生最正确的决定。",
    tags: ["温暖", "成长"],
    views: "259.7万",
  },
  {
    id: 14,
    number: 14,
    title: "生活的重量",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20tired%20young%20mother%20carrying%20groceries%20and%20a%20baby%20bag%20up%20old%20apartment%20stairs%2C%20soft%20afternoon%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20resilient%20weary%20mood&width=640&height=360&seq=young-mother-ep14&orientation=landscape",
    airDate: "2025-04-13",
    duration: "45:21",
    director: "陈望舒",
    cast: "林书言、沈知远、苏敏",
    summary:
      "柴米油盐的重量压在肩上，林晚在无数个疲惫的夜晚里，学会了把眼泪留给最安静的那个瞬间。",
    tags: ["生活", "坚持"],
    views: "204.9万",
  },
  {
    id: 15,
    number: 15,
    title: "母亲的秘密",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20mother%20and%20daughter%20having%20an%20honest%20quiet%20conversation%20in%20a%20dim%20living%20room%2C%20warm%20lamp%20glow%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20emotional%20reveal%20mood&width=640&height=360&seq=young-mother-ep15&orientation=landscape",
    airDate: "2025-04-19",
    duration: "45:13",
    director: "陈望舒",
    cast: "林书言、苏敏、周慕",
    summary:
      "母亲终于说出了压在心底二十多年的秘密。林晚在震惊之后，第一次真正看清了母亲这一生的重量。",
    tags: ["秘密", "母女"],
    views: "247.3万",
  },
  {
    id: 16,
    number: 16,
    title: "拥抱的距离",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20two%20people%20standing%20close%20but%20hesitant%20on%20a%20quiet%20bridge%20at%20sunset%2C%20warm%20orange%20sky%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20longing%20gentle%20mood&width=640&height=360&seq=young-mother-ep16&orientation=landscape",
    airDate: "2025-04-20",
    duration: "45:02",
    director: "陈望舒",
    cast: "林书言、周慕、沈知远",
    summary:
      "相隔一步的距离里，藏着两个人多年的误解与不舍。一次没能完成的拥抱，成了彼此心里最深的遗憾。",
    tags: ["情感", "错过"],
    views: "231.6万",
  },
  {
    id: 17,
    number: 17,
    title: "重逢",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20two%20old%20friends%20meeting%20again%20in%20a%20warm%20cafe%20by%20a%20window%2C%20soft%20afternoon%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20surprised%20warm%20mood&width=640&height=360&seq=young-mother-ep17&orientation=landscape",
    airDate: "2025-04-26",
    duration: "44:57",
    director: "陈望舒",
    cast: "林书言、沈知远、周慕",
    summary:
      "多年未见的人再次出现在林晚面前。过去的误会与当下的选择交织，她终于敢于面对那段被搁置的感情。",
    tags: ["重逢", "情感"],
    views: "218.4万",
  },
  {
    id: 18,
    number: 18,
    title: "学会告别",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20woman%20letting%20go%20a%20paper%20lantern%20into%20a%20calm%20evening%20sky%2C%20soft%20dusk%20colors%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20bittersweet%20release%20mood&width=640&height=360&seq=young-mother-ep18&orientation=landscape",
    airDate: "2025-04-27",
    duration: "45:19",
    director: "陈望舒",
    cast: "林书言、苏敏、沈知远",
    summary:
      "有些告别不是失去，而是成全。林晚学着放下执念，把思念放进心里最柔软的位置，继续往前走。",
    tags: ["告别", "成长"],
    views: "226.1万",
  },
  {
    id: 19,
    number: 19,
    title: "小小的课堂",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20mother%20and%20young%20child%20painting%20together%20at%20a%20small%20table%2C%20colorful%20crayons%2C%20soft%20daylight%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20playful%20tender%20mood&width=640&height=360&seq=young-mother-ep19&orientation=landscape",
    airDate: "2025-05-03",
    duration: "44:50",
    director: "陈望舒",
    cast: "林书言、赵一宁、沈知远",
    summary:
      "女儿到了上幼儿园的年纪，一堂小小的亲子课让林晚重新审视自己作为母亲的每一个选择与不足。",
    tags: ["亲情", "成长"],
    views: "196.7万",
  },
  {
    id: 20,
    number: 20,
    title: "关于原谅",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20two%20people%20shaking%20hands%20in%20reconciliation%20in%20a%20sunlit%20room%2C%20soft%20warm%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20forgiving%20gentle%20mood&width=640&height=360&seq=young-mother-ep20&orientation=landscape",
    airDate: "2025-05-04",
    duration: "45:07",
    director: "陈望舒",
    cast: "林书言、周慕、苏敏",
    summary:
      "周慕带着歉意重新出现，林晚必须在怨恨与原谅之间做出选择。她答案的背后，是一个母亲对孩子的承诺。",
    tags: ["原谅", "情感"],
    views: "213.9万",
  },
  {
    id: 21,
    number: 21,
    title: "屋顶上的星星",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20mother%20and%20daughter%20lying%20on%20a%20rooftop%20looking%20at%20a%20starry%20night%20sky%2C%20soft%20blue%20hour%20glow%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20dreamy%20peaceful%20mood&width=640&height=360&seq=young-mother-ep21&orientation=landscape",
    airDate: "2025-05-10",
    duration: "45:00",
    director: "陈望舒",
    cast: "林书言、沈知远、赵一宁",
    summary:
      "母女俩躺在屋顶数星星，女儿天真的疑问让林晚回望这一路的坎坷，也更加坚定了要把日子过好的决心。",
    tags: ["温暖", "治愈"],
    views: "235.2万",
  },
  {
    id: 22,
    number: 22,
    title: "说出那句话",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20young%20woman%20speaking%20sincerely%20to%20someone%20across%20a%20table%20in%20a%20warm%20lit%20room%2C%20soft%20amber%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20confessional%20emotional%20mood&width=640&height=360&seq=young-mother-ep22&orientation=landscape",
    airDate: "2025-05-11",
    duration: "45:14",
    director: "陈望舒",
    cast: "林书言、周慕、沈知远",
    summary: "藏了太久的那句话终于说出口。林晚不再逃避自己的心，也第一次为自己而不是为孩子做决定。",
    tags: ["告白", "成长"],
    views: "229.8万",
  },
  {
    id: 23,
    number: 23,
    title: "家在哪里",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20still%20of%20a%20woman%20gazing%20at%20a%20warm%20lit%20home%20window%20from%20the%20street%20at%20evening%2C%20soft%20lamplight%20glow%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20contemplative%20warm%20mood&width=640&height=360&seq=young-mother-ep23&orientation=landscape",
    airDate: "2025-05-17",
    duration: "45:09",
    director: "陈望舒",
    cast: "林书言、苏敏、周慕",
    summary:
      "面对去与留的抉择，林晚终于明白，家不是一个地址，而是那个愿意为你留一盏灯的人和地方。",
    tags: ["归宿", "亲情"],
    views: "240.5万",
  },
  {
    id: 24,
    number: 24,
    title: "年轻的母亲",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20drama%20finale%20still%20of%20a%20young%20mother%20holding%20her%20child%20in%20a%20sunlit%20doorway%20surrounded%20by%20family%2C%20golden%20warm%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20hopeful%20heartwarming%20mood&width=640&height=360&seq=young-mother-ep24&orientation=landscape",
    airDate: "2025-05-18",
    duration: "52:36",
    director: "陈望舒",
    cast: "林书言、周慕、苏敏、沈知远",
    summary:
      "全剧大结局。曾经的少女成为了真正的母亲，那些被生活磨出的伤痕，最终开成了照亮整个家的温柔光芒。",
    tags: ["大结局", "成长"],
    views: "312.6万",
  },
];